<script setup lang="ts">
import { useFloatingContactStore } from '../../../../store/contacts/floatingContact.ts';
import { type ContactLinkProps } from '../../FloatingContact.vue';
import ContactLink from '../ContactLink/ContactLink.vue';
import ContactCard from '../../../ContactCard/ContactCard.vue';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';

type Props = {
  navLinks: ContactLinkProps[];
};

defineProps<Props>();

const stateStore = useFloatingContactStore();
const { isL2, isNavigation } = storeToRefs(stateStore);
// TODO: connect to translation service
const title = ref<string>('Quick Links');

const handleLinksClick = () => {
  stateStore.openNavigation();
};
</script>
<template>
  <div :class="$style.container">
    <template v-for="(contactNavLink, index) in navLinks" :key="index">
      <ContactLink
        :has-children="!!contactNavLink.defaultLink.children"
        :icon="contactNavLink.icon"
        :is-external="contactNavLink.defaultLink?.url ? true : undefined"
        :is-mailto="contactNavLink.mailto"
        :is-tel="contactNavLink.tel"
        :show-link="contactNavLink.showLink"
        :text="contactNavLink.text"
        :title="contactNavLink.defaultLink?.title || ''"
        @button-click="handleLinksClick"
      />
      <div v-if="isL2 && isNavigation" :class="$style.floatingContactFlyOut">
        <h3 v-if="contactNavLink.defaultLink.children?.title">
          {{ contactNavLink.defaultLink.children?.title }}
        </h3>
        <template
          v-for="(contact, contactIndex) in contactNavLink.defaultLink.children?.contacts"
          :key="contactIndex"
        >
          <ContactCard
            v-if="contact"
            :additional-text="contact.additionalText"
            :address="contact.address"
            :city="contact.city"
            :company="contact.company"
            :country="contact.country"
            :description="contact.description"
            :email="contact.email"
            :fax="contact.fax"
            :media="contact.media"
            :mobile="contact.mobile"
            :name="contact.name"
            :position="contact.position"
            :street="contact.street"
            :tel="contact.tel"
            :type="contact.type"
            :v-card="contact.vCard"
            :website="contact.website"
            :website-text="contact.websiteText"
          />
        </template>
        <h3 v-if="title && contactNavLink.defaultLink.children?.quickLinks?.length">
          {{ title }}
        </h3>
        <template
          v-for="(quickLinks, quickIndex) in contactNavLink.defaultLink.children?.quickLinks"
          :key="quickIndex"
        >
          <ContactLink
            v-if="quickLinks"
            :icon="quickLinks.icon"
            :is-external="quickLinks.defaultLink?.url ? true : undefined"
            :is-mailto="quickLinks.mailto"
            :is-tel="quickLinks.tel"
            :show-link="quickLinks.showLink"
            :src="quickLinks.defaultLink?.url || ''"
            :text="quickLinks.text"
            :title="quickLinks.defaultLink?.title || ''"
          />
        </template>
      </div>
    </template>
  </div>
</template>
<style lang="sass" module src="./ContactNavigation.scss" />
